import SafeConsole from '../util/ConsoleUtils';
import styled from 'styled-components';

const TitleImageContainer = styled.div`
  .TitleImageContainer {
    .ImageContainer {
      &:before {
        background: none;
      }
    }
    .TitleContainer {
      text-align: left;
      .Title,
      .SubTitle {
        margin: 15px 7%;
        font-weight: normal;
      }
    }
  }
`;

type PartnerStyles = {
  appScheduler: {
    inputStyle: object | null;
    timeZonePickerStyle: object | null;
  };
  learnContainerStyle: {
    backgroundImage: string;
  };
  TitleImageContainer: object;
  experiencesHomeTitleImage: object | null;
  hasExperiencesDetailsTitleImage: boolean;
};

function getPartnerStyles() {
  let partnerStyles: PartnerStyles = {
    appScheduler: {
      inputStyle: null,
      timeZonePickerStyle: null,
    },
    learnContainerStyle: {
      backgroundImage: `linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.9) 70%), url(${require('../resources/ExperienceCards/SuggestTopic.jpg')})`,
    },
    TitleImageContainer: styled.div``,
    experiencesHomeTitleImage: require('../resources/ExperienceCards/Hero.jpg'),
    hasExperiencesDetailsTitleImage: true,
  };
  switch (globals.REACT_APP_PARTNER) {
    case 'SHS-WEB':
      partnerStyles = {
        ...partnerStyles,
      };
      break;
    case 'TCH-WEB':
      partnerStyles = {
        ...partnerStyles,
      };
      break;
    case 'SHS-SPRINT':
      partnerStyles = {
        ...partnerStyles,
        learnContainerStyle: {
          backgroundImage: `linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.9) 70%), url(${require('../resources/ExperienceCards/SHS-SPRINT/SuggestTopic.jpg')})`,
        },
        experiencesHomeTitleImage: require('../resources/ExperienceCards/SHS-SPRINT/Hero.jpg'),
      };
      break;
    case 'SHS-ASURION':
      partnerStyles = {
        ...partnerStyles,
        appScheduler: {
          inputStyle: { borderRadius: 0 },
          timeZonePickerStyle: { borderRadius: 0 },
        },
        learnContainerStyle: {
          backgroundImage: `linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.9) 70%), url(${require('../resources/ExperienceCards/SHS-ASURION/Want-to-Know-More.jpg')})`,
        },
        TitleImageContainer,
        experiencesHomeTitleImage: require('../resources/ExperienceCards/SHS-ASURION/Asurion-header.png'),
        hasExperiencesDetailsTitleImage: false,
      };
      break;
    default:
      SafeConsole.error(
        'globals.REACT_APP_PARTNER is invalid in partnerStylesConfig, globals.REACT_APP_PARTNER = ',
        globals.REACT_APP_PARTNER
      );
      break;
  }
  return partnerStyles;
}

const partnerStyles = getPartnerStyles();
export default partnerStyles;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/config/partnerStylesConfig.tsx